export default __webpack_public_path__ + "static/O0029-944a40fd90279a73f33d4e03f6559da2.png";